import React, { useEffect, useRef, useState } from "react";


const useCountUp = (end, debugLabel = "", duration = 2000) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasStarted = useRef(false);

  useEffect(() => {
    if (!ref.current || hasStarted.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted.current) {
          hasStarted.current = true;
          observer.disconnect(); // keine weiteren Checks nötig
          startCounting();
        }
      },
      { threshold: 0.6 }
    );

    observer.observe(ref.current);

    function startCounting() {
      console.log(`[${debugLabel}] ➤ Starte CountUp bis ${end}`);
      let start = 0;
      let lastDisplayed = 0;
      const increment = end / (duration / 16);

      const step = () => {
        start += increment;
        const current = Math.floor(start);
        if (current !== lastDisplayed) {
          setCount(current);
          lastDisplayed = current;
        }

        if (start < end) {
          requestAnimationFrame(step);
        } else {
          setCount(end);
          console.log(`[${debugLabel}] ✔️ fertig bei ${end}`);
        }
      };

      requestAnimationFrame(step);
    }

    return () => observer.disconnect();
  }, [end, duration]);

  return [count, ref];
};


const KPI1 = () => {
const [kpi1, ref1] = useCountUp(40, "KPI1");
const [kpi2, ref2] = useCountUp(7, "KPI2");
const [kpi3, ref3] = useCountUp(20, "KPI3");
const [kpi4, ref4] = useCountUp(95, "KPI4");


  return (
    <section className="kpi1-section" id="kpi">
        <h2 className="kpi1-heading" id="timeline-scroll">
          Ein visionäres Team. Ein Netzwerk. <br /> Eine Plattform für neue Lösungen.
        </h2>
        <p className="kpi1-subheading" id="start-scroll">
          Mit einem Netzwerk aus exzellenten Talenten und unternehmerischer Klarheit schaffen wir agile Lösungen für reale Herausforderungen – datengestützt, flexibel und effizient.
        </p>
      <div className="kpi1-grid">
        {/* Left: KPI-Zeilen */}
        <div className="kpi1-raw-numbers">
          <div className="kpi1-line" ref={ref1}>
            <span className="kpi1-label">Partner Hochschulen (FT Ranking):</span>
            <span className="kpi1-value" translate="no">{kpi1.toLocaleString("de-DE")}+</span>
          </div>
          <div className="kpi1-line" ref={ref2}>
            <span className="kpi1-label">Durchschnittliche Matching-Zeit (in Tagen):</span>
            <span className="kpi1-value" translate="no">&lt;{kpi2}</span>
          </div>
          <div className="kpi1-line" ref={ref3}>
            <span className="kpi1-label">Teamdiversität Nationalitäten:</span>
            <span className="kpi1-value" translate="no">{kpi3}+</span>
          </div>
          <div className="kpi1-line" ref={ref4}>
            <span className="kpi1-label">Kundenzufriedenheit:</span>
            <span className="kpi1-value" translate="no">{kpi4}%</span>
          </div>
        </div>

        {/* Right: Globe GIF */}
        <div className="kpi1-globe-wrapper">
          <img src="/assets/earthwhite3.png" alt="Globale Vernetzung" className="kpi1-globe" />
        </div>
      </div>
    </section>
  );
};

export default KPI1;
